/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import styled from "styled-components";
//@ts-ignore
import { DynamicCloseIcon } from "../../../assets/icons/DynamicCloseIcon";
//@ts-ignore
import { BlackCoins } from "../../../assets/icons/BlackCoins";
//@ts-ignore
import {useTrack} from '../../../services/hooks/useTrack'

interface IProps {
  isOpen: boolean;
  purchaseCompleted: (id: string, data: { Produto: string; "Valor Giftcard": string; "Preço em blackcoins": number | string; }) => void;
  setIsOpen: () => void;
  ConfirmationInfo: {
    title: string;
    icon: any;
    text: {
      textTitle: string;
      textValue: string;
      textNote: string;
    };
    price: number | string;
    id: string;
    monetaryValue: string;
  };
}

interface IOpenProps {
  isOpen: boolean;
}

const Overlay = styled.div<IOpenProps>`
  width: ${({ isOpen }) => (isOpen ? "100vw" : "0px")};
  height: ${({ isOpen }) => (isOpen ? "100vh" : "0px")};
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9999999999;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ isOpen }) =>
    isOpen ? "rgba(0, 0, 0, 0.7)" : "transparent"};
`;

const Container = styled.div<IOpenProps>`
  background-color: white;
  border-radius: 30px;
  height: clamp(260px, 30%, 400px);
  width: auto;
  aspect-ratio: 9/6;
  padding: 20px;
  padding-right: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 20px;
  border: 2px solid #7515ed;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 2px solid #7515ed;
  padding-right: 20px;
  padding-bottom: 16px;
`;

const Title = styled.p`
  font-size: 18px;
`;

const Close = styled.button`
  background-color: transparent;
  border: none;
  display: flex;
  cursor: pointer;
`;

const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  border: 1px solid #7515ed;
  border-radius: 20px;
  padding: 5px;
  margin-right: 20px;
`;

const ItemIcon = styled.img`
  height: 90px;
  width: 120px;
  object-fit: cover;
  border-radius: 15px;
`;

const ItemContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
`;

const ItemTitle = styled.p`
  font-weight: 700;
`;

const ItemValue = styled.p`
  b {
    font-weight: 700;
  }
`;

const ItemNotes = styled.p`
  font-size: 10px;
`;

const Footer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;

const FooterPrice = styled.p`
  font-weight: 700;
  font-size: 20px;
  i {
    font-style: italic;
    font-weight: 500;
  }
`;

const Purchase = styled.button`
  margin-left: auto;
  margin-right: 20px;
  background-color: #55be54;
  border-radius: 100px;
  color: white;
  border: none;
  padding: 15px 40px;
  cursor: pointer;
`;

export const Confirmation = (props: IProps) => {
  const {trackEvent} = useTrack()
  useEffect(() => {
    trackEvent('Indique - Visualizou modal de confirmação de compra', {
      Produto: props.ConfirmationInfo.text.textValue,
      'Valor Giftcard': props.ConfirmationInfo.monetaryValue,
      'Preço em blackcoins': props.ConfirmationInfo.price,
      'Tipo da origem': 'Indique e ganhe',
    })
  }, [])
  return (
    <Overlay isOpen={props.isOpen}>
      <Container isOpen={props.isOpen}>
        <TitleContainer>
          <Title>{props.ConfirmationInfo.title}</Title>
          <Close onClick={() => props.setIsOpen()}>
            <DynamicCloseIcon />
          </Close>
        </TitleContainer>
        <Item>
          <ItemIcon src={props.ConfirmationInfo.icon} />
          <ItemContent>
            <ItemTitle>{props.ConfirmationInfo.text.textTitle}</ItemTitle>
            <ItemValue>
              <b>{props.ConfirmationInfo.text.textValue}</b>
            </ItemValue>
            <ItemNotes>{props.ConfirmationInfo.text.textNote}</ItemNotes>
          </ItemContent>
        </Item>
        <Footer>
          <BlackCoins />
          <FooterPrice>
            {props.ConfirmationInfo.price} <i>Blackcoins</i>
          </FooterPrice>
          <Purchase
            onClick={() => {
              trackEvent("Indique - Clicou em Confirmar compra", {
                Produto: props.ConfirmationInfo.text.textValue,
                "Valor Giftcard": props.ConfirmationInfo.monetaryValue,
                "Preço em blackcoins": props.ConfirmationInfo.price,
                "Tipo da origem": "Indique e ganhe",
              });
              props.purchaseCompleted(props.ConfirmationInfo.id, {
                Produto: props.ConfirmationInfo.text.textValue,
                "Valor Giftcard": props.ConfirmationInfo.monetaryValue,
                "Preço em blackcoins": props.ConfirmationInfo.price,
              });
            }}
          >
            Comprar
          </Purchase>
        </Footer>
      </Container>
    </Overlay>
  );
};
